var progressbar;

progressbar = function(options) {
  var $, calculateProgress, elemSelectorProgress, initModule, module, moduleName;
  moduleName = 'progressbar';
  $ = require('jquery');
  module = void 0;
  initModule = function() {
    var barColor, barOpacity, body, markup, moduleBar;
    markup = "<div class='" + moduleName + "'> <div class='" + moduleName + "__bar'></div> </div>";
    body = $('body');
    body.prepend(markup);
    module = $("." + moduleName);
    moduleBar = module.find("." + moduleName + "__bar");
    barColor = options.barColor;
    barOpacity = options.barOpacity;
    if (barColor !== void 0) {
      moduleBar.css({
        "background-color": barColor
      });
    }
    if (barOpacity !== void 0) {
      return moduleBar.css({
        "opacity": barOpacity
      });
    }
  };
  elemSelectorProgress = options.elemSelectorProgress;
  calculateProgress = function() {
    var barWidth, cutMinus, elem, elemFromTop, elemHeight, progressBar, progressLength, reverseElemFromTop;
    elem = $(elemSelectorProgress);
    elemFromTop = elem.offset().top - $(window).scrollTop();
    cutMinus = function(int) {
      int = int.toString();
      int = parseInt(int.replace('-', ''));
      return int;
    };
    elemHeight = elem.height();
    reverseElemFromTop = cutMinus(elemFromTop);
    progressBar = module.find("." + moduleName + "__bar");
    if (elemFromTop > 0) {
      progressBar.width(0);
    }
    if (reverseElemFromTop > elemHeight) {
      console.log(reverseElemFromTop);
      progressBar.css({
        'width': '100%'
      });
    }
    if (elemFromTop > 0 || reverseElemFromTop > elemHeight) {
      return false;
    }
    progressLength = module.outerWidth();
    barWidth = (progressLength / elemHeight) * reverseElemFromTop;
    return progressBar.width(barWidth);
  };
  if (options === 'reinit') {
    return false;
  }
  initModule();
  return $(window).scroll(function() {
    return calculateProgress();
  });
};

module.exports = progressbar;
